import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {useStaticQuery, graphql} from 'gatsby';

import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import CustomerStories from './CustomerStories';
import {CustomerStory} from '../../../types';
import {getNodesByLocale} from '../../../localeUtils/getNodesByLocale';

const limit = 3;

function CustomerStoriesQuery(): ReactElement | null {
  const locale = useLocale();
  const {locale: language} = useIntl();

  // CustomerStory Fragment comes from src/components/CustomerStories/CustomerStoriesQuery
  const data = useStaticQuery(graphql`
    query HomepageCustomerStories {
      allContentfulCustomerStories(filter: {shouldShowOnHomePage: {eq: true}}) {
        nodes {
          ...CustomerStory
        }
      }
    }
  `);

  // as this is a static query we need to filter locale content
  const customerStories = getNodesByLocale<CustomerStory>(
    data.allContentfulCustomerStories.nodes,
    locale,
    language as Locale
  );

  if (customerStories.length === 0) {
    return null;
  }

  return <CustomerStories customerStories={customerStories.splice(0, limit)} />;
}

export default CustomerStoriesQuery;
